import React, { useEffect, useRef } from 'react';
import './Modes.css';
import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
import DarkModeToggle, { useDarkMode } from '../DarkModeToggle';

function Modes() {
    const { dark } = useDarkMode();
    const applied = useRef(null);

    useEffect(() => {
        if (applied.current === dark) return;
        applied.current = dark;

        if (dark) {
            enableDarkMode({ brightness: 100, contrast: 90, sepia: 10 });
        } else {
            disableDarkMode();
        }

        Array.from(document.getElementsByClassName('rdw-option-wrapper')).forEach((tool) => {
            tool.style.backgroundColor = 'rgba(126, 126, 126, 0)';
            tool.style.filter = dark ? 'invert(65%)' : 'none';
        });
    }, [dark]);

    return <DarkModeToggle />;
}

export default Modes;
